import esLocale from 'element-ui/lib/locale/lang/es'
const es = { //西班牙语
login:{
buttoo:{
    add:'新增'
}
},
dialog:{
buttton:{
    close:'关闭'
},
ReportError:{
      next:'Next',
 h1:'Report Errors allows users to communicate with us to solve any data issues and improve data quality.',
 li1:'If you find any data problems or have a question about this data',
 li2:'If you want to contribute company information to improve this data',
 li3:'If you choose not to disclose your own company information that you might consider private',
 li4:'If you have any constructive suggestions for us to improve services',
 h2:"All comments submitted are subject to data verification. Users must complete your own user profile as our representative may contact you for authentication and verification of your company any rights to represent your company."
},
},
Home:{
    Applications:'Applications',
  SearchCompanies:'Search Companies',
  SearchTrade:'Search Trade',
  SearchRisks:'Search Risks',
  SearchCountries:'Search Countries',
  SearchNews:'Search News',
  SearchLeads:'Search Leads',
 selectCountry:'Seleccionar país',
 inputCompany:'Ingresar nombre de la empresa',
 keWord:'Palabra clave',
 firstWord:"Texto (palabras de la izquierda)",
 searchCompanyNum:"Search 500+ million companies in 200+ countries and territories",
 search:'Buscar',
 homeSeachTitle:'Enfoque en los negocios globales',
 homeTitleDetail:'CSI, una firma de investigación y TI basada en datos, se especializa en crédito, riesgo y big data. Ofrece herramientas digitales a inversores y profesionales de negocios globales, aprovechando análisis y algoritmos avanzados para brindar información visual y rápida que facilita una toma de decisiones más inteligente.',
 phoneTitleDetail:'Para buscar, ver y obtener información de la empresa rápidamente, también puede usar la aplicación de CSI en su teléfono.',
 IndustryAnalysis :'Industry Analysis',
BusinessAnalytics :'Business Analytics',
ImportExportData :'Import-Export Data',
CompanyNews :'Company News',
Sanctions :'Sanctions',
SearchLeads:"Search Leads",
BusinessIntelligence :'Business Intelligence',
CompanyIdentityVerification :'Company Identity Verification',
KYCSolutions :'KYC Solutions',
OwnershipPenetration :'Ownership Penetration',
CompanyFinancialAnalysis:'Company Financial Analysis',
CreditRatings :'Credit Ratings',
CreditReports :'Credit Reports',
ESGRatings :'ESG Ratings',
VendorScreening :'Vendor Screening ',
MarketResearch:'Market Research ' 
},
IndustryStatistics:{
    SubjectCompany:"Empresa",
    Country:"País",
    Compare:"Comparar",
    Industry:"Sector",
    CompanyType:"Tipo de empresa",
    CompanySize:"Tamaño de la empresa",
    CompanyStatus:"Estado de la empresa",
    YearsinBusiness:"Años en el mercado",
    CompanyRating:"Calificación de la empresa"
},
ListofResults:{
  SelectCountry:'Select Country',
  ClearAll:'Clear All',
  SelectIndustry:'Select Industry',
  ListedCompany:'Listed Company',
  YearsinBusiness:'Years in Business',
   Sharethisinformation:'Share this information',
  Pleaseaddress:'Please enter one or more email address',
  Example:'Example',
  message:'message',
  pleaseleaveamessage:'please leave a message',
  Include:'',
  thisaddress:'this company name,ID,address',
  CSIwebsite:'CSI website',
  Update:'Update',
  Iftheavailable:'If the available online data is insufficient or outdated, you can click the “Update” button to request an instant update for a fresh investigated business credit report from our local networking investigators or credit reporting agencies. The cost for this update is 1 credit per company. The update report typically takes between 24 and 72 hours to be delivered.',
  Abusinesscredit :'A business credit report provides detailed information about the subject company’s identification data, registry records, shareholding structure, company history, management description, related companies, actual operations, trade references, financial data and analysis, official public information such as litigation records and sanctions, and credit analysis and assessment.',
  Searchcompanies:'Search more emails on other companies',
  Rowsperpage:'Rows per page',
     CountyCity:'County/City'

},
Toolbar:{
    Filter:"Filtrar",
    Select:"Seleccionar",
    Edit:"Editar",
    Sortby:"Ordenar por",
    Collect:"Recopilar",
    Saved:"Guardados",
    Compare:"Comparar",
    Export:"Exportar",
    Download:"Descargar",
    Update:"Actualizar",
    Reporterror:"Informar de un error",
    Share:"Compartir",
      ascending:'ascending',
    descending:'descending',
    Customfolder:'Custom folder'
},
AiZaba:{
whatareyousearchingfor:'what are you searching for',
CreditAnalyst:'Credit Analyst',
Assesses:"Assesses a company'screditworthiness,identifiesfinancial risks,ensuring secure transactionsthrough data analysis andcredit ratings.",
LegalAdvisor:"Legal Advisor",
Provides:'Provides compliance guidance,reviews contracts,andassesseslegarisks to ensure businessoperations align with lawsand avoid disputes.',
BizConsultant:'Biz Consultant',
Optimizes:'Optimizes supply chains,identifiesbuyers, andboosts sales by analyzingmarket trends and offeringtailored strategies to improve efficiency',
EconomicAnalyst:'Economic Analyst',
Analyzes:"Analyzes industry and regional economic trendshelping businesses makeinformed decisions, and staycompetitive."
},
ContentTabs:{
    Background:"Antecedentes",
    BusinessActivities:"Actividades comerciales",
    Performance:"Rendimiento",
    Publications:"Publicaciones",
    CreditOpinion:"Opinión crediticia",
    MarketAnalysis:"Análisis de mercado",
    Snapshot:"Panorama general",
    Profile:"Perfil",
    Ownership:"Propiedad",
    RelatedCompanies:"Empresas relacionadas",
    Management:"Administración",
    Operations:"Operaciones",
    Locations:"Ubicaciones",
    Industry:"Sector",
    ImportExport:"Importación y exportación",
    SupplyChain:"Cadena de suministro",
    FinancialHighlights:"Información financiera destacada",
    RatioAnalysis:"Análisis de ratios",
    IndustryNorm:"Norma del sector",
    News:"Noticias",
    Sanctions:"Sanciones",
    IndustryStatistics:"Estadísticas del sector",
    RatingAnalysis:"Análisis de calificación",
    CompetitiveAnalysis:"Análisis competitivo"
},
navigationBar:{
Notifications:'Notificaciones',//通知
MarkasRead:'Marcar como leído',//标记已读
Viewall:'Ver todo',//查看全部
SilverSubscriber:'Suscriptor Plata',//银级用户
Silversubscriberdate:'Fecha de vencimiento de la suscripción Plata',//银级到期日
GoldSubscriber:'Suscriptor Oro',//金级用户
Goldsubscriptiondate:'Fecha de vencimiento de la suscripción Oro',//金级到期日
AvailableCredits:'Créditos disponibles',//可用积分
AddCredits:'Añadir créditos',//购买积分
IndivdualAccount:'Cuenta individual', //个人账号
GroupAccount:'Cuenta de grupo' //集团账号

},
Snapshot:{
    CompanyDQIdesc:"The Data Quality Index (DQI) employs algorithms to assess different aspects of data, including completeness, validity, reliability of sources, consistency, timeliness, and bilingual support.The index is designed to assess the quality of data on a scale of 1 to 100, with higher scores indicating superior data quality. Algorithms can analyze data based on predefined rules or criteria, enabling objective and standardized measurements.Our Data Quality Index (DQI) serves as a reliable indicator, allowing users to quantitatively assess data quality. This enables data-driven decision-making and enhances the overall value and utility of the data.",
  CountryDQIdesc:"The Data Quality Index (DQI) assesses the reliability, accuracy, and accessibility of data across countries, reflecting differences in digital infrastructure, governance, and transparency. Developed nations typically rank higher due to strong data systems, open policies, and advanced technology, while developing economies often struggle with gaps in infrastructure, regulation, or data-sharing practices. Key factors include government transparency, data protection laws, and technological adoption. A high DQI enables better policymaking and business decisions, while a low score highlights areas needing investment.",
  CompanyDQI:'Índice de Calidad de la Empresa',//公司数据质量指数 DQI
  CountryDQI:'IQD del País',//国家数据质量指数 DQI
  Address:'Dirección',//地址
  CountyCity:'Condado/Ciudad',//县/市
  ProvinceState:'Provincia/Estado',//省/州
  CountryRegion:'País/Región',//国家/地区
  ZipCode:'Código Postal',//邮政编码
  Website:'Sitio Web',//网站
  Email:'Correo Electrónico',//电邮
  Tel:'Teléfono',//电话
  LastUpdate:'Última Actualización',//最近更新
  DataSource:'Fuente de Datos',//数据来源
  LegalStatus:'Estatus Legal',//法定状况
  CoID:'ID de la Empresa',//公司ID
  CompanyType:'Tipo de Empresa',//公司类型
  RegistrationDate:'Fecha de Registro',//注册日期
  RegistrationStatus:'Estado de Registro',//注册状态
  Listed:'Cotizada',//上市信息
  CurrentOpperations:'Operaciones Actuales',//经营状况
  IndustryCode:'Código de Sector',//行业代码
  BusinessActivities:'Actividades Comerciales',//主营业务
  NoofEmployees:'N.° de Empleados',//员工数量
  NoofShareholders:'N.° de Accionistas',//股东数量
  Management:'Administración',//管理状况
  Performance:'Rendimiento',//业绩表现
  Revenue:'Ingresos',//收入
  Assets:'Activos',//资产
  ProfitLoss:'Ganancias/Pérdidas',//利润
  Growth:'Crecimiento',//公司增长
  Competitiveness:'Competitividad',//竞争力
  CreditOpinion:'Opinión Crediticia',//信用状况
  CreditRating:'Calificación Crediticia',//信用评级
  CreditScore:'Puntuación Crediticia',//信用评分
  ESGRating:'Calificación ESG',//ESG 评级
  Solvency:'Solvencia',//偿还能力
  Sanctions:'Sanciones',//全球制裁
},
Profile:{
  CompanyProfile:'Perfil de la empresa',//基本资料
  CompanyName:'Nombre de la empresa',//公司名称
  NativeName:'Nombre de la empresa',//当地名称
  CompanyID:'ID de la empresa',//公司 ID
  VATNumber:'Número de IVA',//VAT号
  StockCode:'Código bursátil',//股票代码
  Listed:'Cotización',//上市日期
  RegistrationDate:'Fecha de registro',//注册日期
  LegalForm:'Forma jurídica',//公司性质
  CompanyType:'Tipo de empresa',//公司类型
  LegalStatus:'Estatuto jurídico',//注册状态
  Jurisdiction:'Jurisdicción',//司法管辖区
  RegisteredAddress:'Domicilio social',//注册地址
  ProvinceState:'Provincia/Estado',//省/州
  CountryRegion:'País/Región',//国家/地区
  ZipCode:'Código postal',//邮政编码
  OperatingAddress:'Dirección operativa',//经营地址
  LastUpdate:'Última actualización',//最近更新
  DataSource:'Fuente de datos',//数据来源
  History:'Historial',//历史记录
    RegisteredCapital:'Registered Capital',
  PaidinCapital:'Paid-in Capital',
       CountyCity:'County/City'
},
Ownership:{
 UltimateBeneficiary:'Spanish',//最终受益人
  InvolvingIndividuals:'Involucrando a personas físicas',//涉及自然人股东
  InvolvingEnterprises:'Involucrando a empresas',//涉及法人股东
  ShareholderLevel:'Nivel de accionista',//股东层级x
  Name:'Nombre',//名称
  Country:'País',//国家/地区
  Location:'Ubicación',//地点
  Type:'Tipo',//类型
  Shares:'Acciones',//股份
  Relation:'Relación',//关系
    Individuals :'Individuals',//关系
        PartiesInvolved:'Parties Involved',
  RelatedCompany:'Related Company',
  CompanyShareholders:'Company Shareholders',
  NGOShareholders:'NGO Shareholders',
  NaturalPersonShareholder:'Natural Person Shareholder',
  SubjectInvestments:"Subject's Investments"
},
RelatedCompanies:{
 Total:'Total',//相关公司总计
  Entities:'Entidades',//法人实体
  Countries:'Países',//国家/地区
  Branches:'Sucursales',//分支机构
  RelatedComp:'Empresas relacionadas',//关联公司
  Name:'Nombre',//名称
  Country:'País',//国家/地区
  Location:'Ubicación',//地点
  Type:'Tipo',//类型
  Relation:'Relación',//关系
  BranchOffices:'Branch Offices',
  Individuals:'Individuals',
},
Management:{
  Total:'Direccion',//管理层
  ContactInfo:'Información de contacto',//联系人信息
  Countries:'Países',//国家/地区

  Name:'Nombre',//名称
  Position:'Puesto',//职位
  Department:'Departamento',//部门
  Country:'País',//国家/地区
  ShareholderNot:'Accionista o no',//是否股东
  Relation:'Relaciones',//关系
  Verification:'Verificación',//已验证
  Searchmoreemails:'Buscar más correos electrónicos',//搜索更多电邮
  Roles:'Roles',//角色
  EducationLevel:'Nivel educativo',//教育程度
  Phone:'Teléfono',//电话
  Email:'Correo electrónico',//电邮
  Verified:'Verificado',//已验证
  Searchmore:'Buscar más correos electrónicos de otras empresas',//搜索更多其他公司的电邮
},
Operations:{
    Operations:'Operations',
  LineofBusiness:'Línea de negocio',//业务范围
  BusinessTerritories:'Territorios comerciales',//业务区域
  ImportExport:'Importación y exportación',//进出口信息
  Viewtradeinfo:'Ver más información comercial',//查看更多贸易信息
  ProductsServices:'Productos/Servicios',//产品/服务
  Products:'Productos',//产品
  ProductImage:'Imagen del producto',//产品图片
  ProductName:'Nombre del producto',//产品名称
  ProductDescription:'Descripción del producto',//产品描述
  Details:'Detalles',//详情
  Addproductinformation :'Añadir información del producto',//添加产品信息
},
Locations:{
   Locations:"Locations",
  CoName:'Nombre de la empresa',//业务范围
  Relationship:'Relación',//关系
  Country:'País',//国家/地区
  Location:'Ubicación',//地点
  Address:'Dirección',//地址
  Edit:'Editar',//编辑
  CompanyLocatiionsMap:'Ubicaciones de la empresa en el mapa',//地图中的公司位置
  Selectaddresstype:'Seleccionar tipo de dirección',//选择地址类型
  Subjectcompany:'Empresa objeto',//目标公司
  Subsidiary:'Filial',//子公司
  RegisteredAddress :'Domicilio social',//注册地址
  OperationAddress :'Dirección operativa',//运营地址
  All :'Todos',//全部
},
Industry:{
  IndustryTitle:'Título de la industria',//IndustryTitle
  IndustryDescription:'Descripción de la industria',//IndustryDescription
  ISIC:'CIIU',//ISIC
  ISICDescription:'Descripción CIIU',//ISICDescription
  NACE:'NACE',//NACEDescription
  NACEDescription:'Descripción NACE',//NACEDescription
  NAICS:'NAICS',//NAICS
  NAICSDescription:'Descripción NAICS',//NAICSDescription
  CSIC:'CSIC',//CSIC, 
  CSICDescription:'Descripción CSIC',//CSICDescription
  AAAIC:'AAAIC',//AAAIC
  AAAICDescription :'Descripción AAAIC',//AAAICDescription
  GICS :'GICS',//GICS
  GICSDescriptio :'Descripción GICS',//GICS 描述
},
ImportExport:{
  TotalImportAmount:'Importe total de importación',//进口总额
  TopImportCountry:'Principales países de importación',//最大进口国家/地区
  TopImportProduct:'Principales productos de importación',//最大进口产品
  TotalExport:'Exportación total',//出口总额
  TopExportCountry:'Principales países de exportación',//最大出口国家/地区
  TopExportProduct:'Principales productos de exportación',//最大出口产品
  TradeVolume:'Volumen comercial',//贸易额
  ImportShipments:'Envíos de importación',//进口量
  ExportShipments:'Envíos de exportación',//出口量
  ImportCountries:'Países de importación',//进口国家/地区
  ExportCountries:'Países de exportación',//出口国家/地区
  ImportVolume:'Volumen de importación',//进口量
  ExportVolume:'Volumen de exportación',//出口量
  TopSuppliers:'Principales proveedores',//主要供应商
  ByNumberofShipments:'Por número de envíos',//按出货量
  TopBuyers:'Principales compradores',//主要买家
  ByNumberofShipments:'Por número de envíos',//按出货量
  ImportQuantity:'Cantidad de importación',//进口数量
  IncreaseDecreasexRate:'Tasa de aumento/disminución',//增/减率
  ExportQuantity:'Cantidad de importación',//出口数量
  ImportsExportsRecords:'Registros de importaciones y exportaciones',//进出口记录
  Date:'Fecha',//日期
  Product:'Producto',//产品
  HSCode:'Código SA',//HS 编码
  BuyerName:'Nombre del comprador',//买家名称
  Destination:'Destino',//目的地
  SupplierName:'Nombre del proveedor',//供应商名称
  Origin:'Origen',//原产地
  Amount:'Cantidad',//金额
  Details:'Details',//详情
},
 FinancialHighlight:{
    ProfitabilityRatios:'Profitability Ratios',
  OperatingRatios:'Operating Ratios',
  StructuralRatios:'Structural Ratios',
ProductivityRatios:'Productivity Ratios',
GrowthRatios:'Growth Ratios',
  Revenue:'Ingresos',//收入
  Profit:'Beneficios',//利润
  Growth:'Crecimiento',//增长
  Liquidity:'Estado del flujo de caja',//现金流状况
  FinancialStructure:'Estructura financiera',//融资结构
  CreditOpinion:'Opinión crediticia',//信用评估
  RiskIndicator :'Indicador de riesgo',//风险指标
  Solvencyindex:'Índice de solvencia',//偿还指数
  Year:'Año',//年份
  Change:'Cambio',//变化
  FinancialHighlights:'Datos financieros de las empresas vinculadas',//关联公司财务数据
  FinancialHighlightsTitle:'Información financiera destacada de las empresas vinculadas',//关联公司财务摘要
  CompanyName:'Nombre de la empresa',//公司名称
  CompanyID:'ID de la empresa',//公司ID
  Country:'País',//国家/地区
  CompanyStatus:'Estado de la empresa',//公司状态
  Relations:'Relaciones',//关系
  RatioAnalysis:'Análisis de índices de las empresas vinculadas' //关联公司比率分析
},
IndustryNorms:{
    IndustryStatistics:"Estadísticas del sector",
    ofcompaniesintheIndustry:"N.° de empresas del sector",
    oflistedCompaniesintheIndustry:"N.° de empresas que cotizan en bolsa en el sector",
    oflargecompaniesintheIndustry:"N.° de grandes empresas del sector",
    ofSMEsintheIndustry:"N.° de pymes del sector",
    ofcompaniesinsample:"N.° de empresas de la muestra",
    ofcompaniesinloss:"N.° de empresas con pérdidas",
    Observations:"Observaciones",
    AverageValue:"Valor medio",
    MedianValue:"Valor medio",
    MaximumValue10:"Valor máximo 10%",
    MinimumValue10:"Valor mínimo 10%",
    SubjectCompany:"Empresa en cuestión",
    YearsinBusiness:"Años en el mercado",
    TotalAssets:"Activos totales",
    TotalEquity:"Patrimonio neto total",
    Revenue:"Ingresos",
    NetEarning:"Beneficio neto",
    Returnonassets:"Rentabilidad de los activos",
    Performance:"Rendimiento",
    ProfitabilityRatios:"Ratios de rentabilidad",
    Returnonequity:"Rentabilidad del patrimonio neto",
    Returnonassets:"Rentabilidad de los activos",
    Grossmargin:"Margen bruto",
    OperatingRatios:"Ratios operativos",
    Stockturnover:"Rotación de existencias",
    Accountsreceivableturnover:"Rotación de cuentas por cobrar",
    Assetsturnover:"Rotación de activos",
    Totalassetturnover:"Rotación de activos totales",
    StructuralRatios:"Ratios de estructura",
    Currentratio:"Ratio de liquidez",
    Quickratio:"ratio de liquidez inmediata",
    Shareholdersliquidityratio:"Ratio de liquidez de los accionistas",
    GrowthRatios:"Ratios de crecimiento",
    Salesgrowthrate:"Tasa de crecimiento de las ventas",
    Netprofitgrowthrate:"Tasa de crecimiento del beneficio neto",
    Totalassetsgrowthrate:"Tasa de crecimiento de los activos totales"
},
 News:{
  Date:'Fecha',//日期
  Title:'Título',//标题
  Source:'Fuente',//来源
  Impact:'Impacto',//影响
  Searchcompanies:'Buscar más noticias sobre otras empresas',//国家/地区
},
Sanctions:{
  Potentialcompliance:'Se detectaron posibles riesgos de incumplimiento.',//检测到潜在合规风险
  SeachbuttonNo:'No se detectó ningún problema en esta empresa.',//未检测到任何与该公司相关的不良记录
  SeachbuttonYes:'Para buscar más registros de sanciones, haga clic en el botón "Buscar sanciones".',//要搜索更多制裁记录，请点击“搜索制裁”按钮。
  SearchSanctions:'Buscar sanciones',//搜索制裁
  ViewDetails:'Ver detalles',//查看详情
  Sanctions:'Sanciones',//制裁
  Potentialcompliancerisks:'Posibles riesgos de incumplimiento',//潜在合规风险
  IDInfo:'Información de ID',//ID 信息
  IDType:'Tipo de ID',//ID 类型
  IDDescription:'Descripción de ID',//ID 描述
  SanctionList:'Lista de sanciones',//制裁名单
  SanctionListInvolved:'Lista de sanciones involucradas',//涉及的制裁名单
  StartDate:'Fecha de inicio',//生效日期
  EndDate:'Fecha de finalización',//结束日期
  SourceList:'Lista de fuentes',//来源名单
  SourceName:'Nombre de la fuente',//来源名称
  ProfileNotes:'Notas del perfil',//主体资料
  Link:'Enlace',//链接
},
CreditOpinion:{
    CreditAssessment:"Evaluación crediticia",
    CreditAssessmentfromtheRelatedCompanies:"Evaluación crediticia de las empresas relacionadas",
    Year:"Año",
    CreditRating:"Calificación crediticia",
    LocalCreditScore:"Puntuación crediticia local",
    ProbabilityofDefault:"Probabilidad de incumplimiento",
    SolvencyIndex:"Índice de solvencia",
    CreditLine:"Línea de crédito",
    RiskIndicator:"Indicador de riesgo",
    RelatedCreditAssessment:"Evaluación crediticia relacionada",
    CompanyName:"Nombre de la empresa",
    CompanyID:"ID de la empresa",
    Country:"País",
    CompanyStatus:"Estado de la empresa",
    Relations:"Relaciones"
},
RatingAnalysis:{
    IndustyAnalysis:"Análisis del sector",
    GeographicAnalysis:"Análisis geográfico",
    CompanyTypeAnalysis:"Análisis del tipo de empresa",
    BiusinessScaleAnalysis:"Análisis de la escala de negocio",
    HistoryAnalysis:"Análisis histórico",
    NormalDistribution:"Distribución normal",
    SubjectCompany:"Empresa del sujeto",
    Probabilityofthesubjectratinginitsindustry:"Probabilidad de la calificación del sujeto en su sector",
    Maximum:"Máximo 10%",
    Mean:"Media",
    Average:"Promedio",
    Minimum:"Mínimo 10%",
    RatingDistribution:"Distribución de la calificación",
    Revenue:"Ingresos",
    Earning:"Ganancias",
    TotalAssets:"Activos totales",
    Subjectratinginitsindustrybyfinancialindicators:"Calificación del sujeto en su sector según indicadores financieros",
    Best:"Mejor",
    Worst:"Peor",
    Rankingofsubject:"Clasificación de la calificación del sujeto en el sector",
    Industy:"Sector",
    Percentilerank:"Percentil: % de empresas con una calificación igual o inferior a la del sujeto",
    Historicaldevelopmentofsubject:"Evolución histórica de la calificación del sujeto en su sector",
    IndustryAverage:"Promedio del sector",
    SubjectRatingChanges:"Cambios en la calificación del sujeto"
},
CompetitiveAnalysis:{
    MarketPosition:"Posición en el mercado",
    Revenus:"Ingresos",
    NetEarnings:"Beneficio neto",
    NetAssets:"Activo neto",
    TotalAssets:"Activo total",
    Employees:"Empleados",
    Mean:"Media",
    Average:"Promedio",
    Maximum:"Máximo (10%)",
    Worst:"Peor (10%)",
    Subjectcompany:"Empresa en cuestión",
    PerformanceComparison:"Comparación de rendimiento",
    ProfitabilityRatios:"Ratios de rentabilidad",
    Grossmargin:"Margen bruto",
    Returnonassets:"Rendimiento sobre activos",
    Returnonequity:"Rendimiento sobre el capital",
    Average:"Promedio",
    OperatingRatios:"Ratios operativos",
    Stockturnover:"Rotación de existencias",
    Assetsturnover:"Rotación de activos",
    Collectionperiod:"Periodo de cobro",
    GrowthRatios:"Ratios de crecimiento",
    Totalassetsgrowthrate:"Tasa de crecimiento de los activos totales",
    Salesgrowthrate:"Tasa de crecimiento de las ventas",
    Netprofitgrowthrate:"Tasa de crecimiento del beneficio neto",
    StructuralRatios:"Ratios de estructura",
    Debtratio:"Ratio de endeudamiento",
    Quickratio:"ratio de liquidez inmediata",
    Currentratio:"Ratio de liquidez"
},
AccountCenterMenu:{
SearchinSettings:"Buscar en Configuración",//在“设置”中搜索
Account:"Cuenta",//账户
MyAccount :"Mi cuenta",//我的账户
ContactInfo:"Información de contacto",//联系信息
AccountSecurity:"Seguridad de la cuenta",//账户安全
OrganizationalManagement:"Gestión de la organización",//组织管理
UserGroup:"Grupo de usuarios",//用户组
User:"Usuario",//用户
Role:"Rol",//角色
MyDatabase:"Mi base de datos",//我的数据库
MyUsage:"Mi uso",//我的使用情况
CompaniesViewed:"Empresas consultadas",//查看过的公司
ReportsDownloaded:"Informes descargados",//下载的报告
ReportUpdatesOrdered:"Actualizaciones de informes solicitadas",//订购的报告更新
BillingandPayment:"Facturación y pagos",//账单和付款
BillRecords:"Registros de facturas",//账单记录
PaymentRecords:"Registros de pagos",//付款记录
CreditDeductions:"Deducciones de crédito",//信用扣款
InvoicesDownloaded:"Facturas descargadas",//下载的发票
UserSettings:"Configuración de usuario",//用户设置
Messages:"Mensajes",//消息
Notifications:"Notificaciones",//通知
HelpCenter:"Centro de ayuda",//帮助中心
FAQ:"Preguntas frecuentes",//常见问题
Privacy:"Privacidad",//隐私
Terms:"Términos",//条款
ReportIssues:"Informar de problemas",//报告问题
UserGuide:"Guía del usuario",//用户指南
AboutCSI:"Acerca de CSI"//关于CSI


},
MyAccount:{
Logintime:'登录时间',//登录时间
SignOut:'退出',//退出
DeleteAccount:'删除账户',//删除账户
AccountID:'账户ID',//账户ID
Enteranewaddress:'输入新的电邮',//输入新的电邮
EnterVerificationCode:'输入验证码',//输入验证码
SendverificationCode:'发送验证码',//发送验证码
Password:'密码',//密码
Originalpassword:'原始密码',//原始密码
Newpassword:'新密码',//新密码
Confirmnewpassword:'确认新密码',//确认新密码
AccountOwnership:'账户所有权',//账户所有权
IndividualAccount:'个人账户',//个人账户
GroupAccount:'集团账户',//集团账户
Organizationname:'机构名称',//机构名称
CountryRegion:'国家/地区',//国家/地区
Address:'地址',//地址
City:'城市',//城市
ZipCode:'邮政编码',//邮政编码
FirstName:'名字',//名字
LastName:'姓氏',//姓氏
PhoneNumber:'电话号码',//电话号码
Email:'电邮',//更改
Change:'更改',//更改
Save:'保存',//保存
Cancel:'取消',//取消
LastLogin:'Last Login',//Last Login
RecentLogin:'登录尝试次数',//登录尝试次数
AverageLoginTime:'平均登录时间',//平均登录时间
TotalLoginAttempts:'登录尝试次数',//登录尝试次数

},
ShippingOrderDetails:{
    Date:"Fecha",
    MasterBillofLading:"Conocimiento de Embarque Maestro",
    Source:"Origen",
    BillNo:"N.° de conocimiento",
    ImporterBuyer:"Importador/Comprador",
    ExporterSeller:"Exportador/Vendedor",
    Name:"Nombre",
    Address:"Dirección",
    Country:"País",
    Contact:"Contacto",
    Email:"Correo electrónico",
    CargoInfo:"Información de la carga",
    HSCode:"Código SA",
    Quantity:"Cantidad",
    WeightUnit:"Unidad de peso",
    ProductDescription:"Descripción del producto",
    Amount:"Importe",
    QuantityUnit:"Unidad de cantidad",
    Weight:"Peso",
    HSDescription:"Descripción SA",
    Incoterms:"Incoterms",
    ShippingInfo:"Información de envío",
    Vessel:"Buque",
    Consignee:"Destinatario",
    MeansofTransport:"Medio de transporte",
    CountryofOrigin:"País de origen",
    Voyage:"Viaje",
    Notifier:"Notificador",
    CountryofDestnation:"País de destino",
    AddressofOrigin:"Dirección de origen",
    Shipper:"Expediente",
    AddressofDestnation:"Dirección de destino",
    Container:"Contenedor",
    ContainerID:"ID del contenedor",
    ContainerType:"Tipo de contenedor",
    ContainerDescDode:"Dirección de descripción del contenedor",
    ContainerSize:"Tamaño del contenedor"
},
ReportIssues:{
    Whattypeoferrorsyouarereporting:"Qué tipo de errores reporta?",
    Tellusmoreaboutyourproblems:"Cuéntenos más sobre sus problemas.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:"Desea proporcionar una captura de pantalla o un archivo sobre su problema?",
    Fillinyourcontactinformation:"Complete su información de contacto",
    FirstName:"Nombre",
    LastName:"Apellidos",
    PhoneNumber:"Número de teléfono",
    Email:"Correo electrónico"
},
UserSettings:{
    LanguageandLocation:"Idioma y ubicación",
    Language:"Idioma",
    Selectyourpreferedlanguage:"Seleccione su idioma preferido",
    Location:"Ubicación",
    Selectyourlocation:"Seleccione su ubicación",
    NotificationSetting:"Configuración de notificaciones",
    EmailNotification:"Notificaciones por correo electrónico",
    ServiceUpdates:"Actualizaciones del servicio",
    CompanyNews:"Noticias de la empresa"
},
ContactInfo:{
    ContactInfo:"Información de contacto",
    FirstName:"Nombre",
    LastName:"Apellidos",
    PhoneNumber:"Número de teléfono",
    Email:"Correo electrónico",
    CountryRegion:"País/Región",
    AddressLine:"Dirección",
    City:"Ciudad",
    ZipCode:"Código postal",
    Alternativecontactperson:"Persona de contacto alternativa",
    Setascontactperson:"Establecer como persona de contacto",
    Edit:"Editar"
},
AccountSecurity:{
    Setupmysecurityquestions:"Configurar mis preguntas de seguridad",
    Pleasechooseaquestion:"Elige una pregunta",
    Pleaseentertheanswertothequestion:"Introduce la respuesta a la pregunta",
    SessionTimeoutAutomaticLogoutSettings:"Tiempo de espera de la sesión: Configuración de cierre de sesión automático",
    Thesystemwillautomatically:"El sistema cerrará tu sesión automáticamente tras un periodo de inactividad. El tiempo de espera predeterminado es de 5 minutos, pero puedes ajustarlo según tus necesidades."
},
MyDatabase:{
    TotalNumberofCompaniesSearched:"Número total de empresas buscadas",
    TotalNumberofCompaniesCollected:"Número total de empresas recopiladas",
    TotalNumberofUpdateReportsOrdered:"Número total de informes de actualización solicitados",
    Date:"Fecha",
    UserName:"Nombre de usuario",
    CompanyName:"Nombre de la empresa",
    Status:"Estado",
    UsageType:"Tipo de uso",
    Entercompanyname:"Introduzca el nombre de la empresa",
    Download:"Descargar"
},
OrganizationalManagement:{
    GroupName:"Nombre del grupo",
    ParentGroupName:"Nombre del grupo principal",
    Organization:"Organización",
    GroupID:"ID del grupo",
    GroupStatus:"Estado del grupo",
    Operation:"Operación",
    NewlyBuilt:"Creado recientemente",
    UserAccount:"Cuenta de usuario",
    Role:"Rol",
    AccountStatus:"Estado de la cuenta",
    RoleName:"Nombre del rol",
    Position:"Posición",
    RoleStatus:"Estado del rol",
    Valid:"Válido",
    Invalid:"Inválido",
    PermissionSettings:"Configuración de permisos"
},
BillingandPayment:{
    TotalNumberofOrders:"Número total de pedidos",
    TotalPaymentAmount:"Importe total del pago",
    TotalDeductionCredits:"Créditos deducidos totales",
    Date:"Fecha",
    UserAccount:"Cuenta de usuario",
    CompanyName:"Nombre de la empresa",
    OrderNo:"N.º de pedido",
    OrderType:"Tipo de pedido",
    OrderStatus:"Estado del pedido",
    Download:"Descargar",
    PaymentAmount:"Importe del pago",
    Contactus:"Contáctenos",
    DownloadInvoice:"Descargar factura",
    CreditsDeducted:"Créditos deducidos",
    ReportOrderStatus:"Informar del estado del pedido",
    CompanyID:"ID de la empresa",
    CountryRegion:"País/Región",
    AddressLine:"Dirección",
    City:"Ciudad",
    ZipCode:"Código postal",
    FirstName:"Nombre",
    LastName:"Apellidos",
    PhoneNumber:"Número de teléfono",
    Email:"Correo electrónico",
    BankAccountHolderName:"Nombre del titular de la cuenta bancaria",
    BeneficiaryBankName:"Nombre del banco beneficiario",
    SWIFTCODE:"CÓDIGO SWIFT",
    AccountNumber:"Número de cuenta",
    BeneficiaryBankAddress:"Dirección del banco beneficiario",
    ABA:"ABA (Número de ruta)",
    IBANnumber:"Número IBAN"
},
JiuGuoge:{
  Country:'Country',
  Industry:'Industry',
  CoSize:'Co. Size',
  Liquidity:'Liquidity',
  NoofcoinIndustry:'No. of co. in Industry',
  IndustryRating:'Industry Rating',
  Profitability:'Profitability',
  Growth:'Growth',
  FinancialStructurt:'Financial Structurt',
  Repaying:'Repaying',
},
  ...esLocale
}

export default es